import { DatePipe } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, ChangeDetectionStrategy, Component, output, signal } from '@angular/core';
import { ShiftLog } from '../../../models/shift-log.model';
import { ShiftColumnKey } from '../../../models/shift-column.model';
import { SHIFT_COLUMNS } from './shift-table-config';
import { BaseTableComponent } from '../../../models/base-table-component.model';
import { ZebraShadowRowsDirective } from '../../../shared/directives/zebra-shadow-rows/zebra-shadow-rows.directive';

@Component({
  selector: 'dr-ops-stream-ui-shift-table',
  templateUrl: './shift-table.component.html',
  styleUrls: ['./shift-table.component.scss'],
  imports: [ZebraShadowRowsDirective, DatePipe],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShiftTableComponent extends BaseTableComponent<ShiftLog, ShiftColumnKey> {
  viewLog = output<ShiftLog>();
  editLog = output<ShiftLog>();

  constructor() {
    super(signal(SHIFT_COLUMNS));
  }

  protected onView(log: ShiftLog) {
    this.viewLog.emit(log);
  }

  protected onEdit(log: ShiftLog) {
    this.editLog.emit(log);
  }
}
